import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';

export default function SchoolResultsPage() {
  // Set page title and meta tags
  useEffect(() => {
    document.title = '미래인재학원 내신실적 - 중고등 성적';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '미래인재학원의 내신 성적 향상 사례를 확인하세요. 체계적인 학습 관리로 학생들의 성적을 크게 향상시킨 실제 사례를 소개합니다.');
    }
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', '미래인재학원 내신 성적 향상 사례 - 중고등 성적 관리');
    }
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', '미래인재학원의 내신 성적 향상 사례를 확인하세요. 체계적인 학습 관리로 학생들의 성적을 크게 향상시킨 실제 사례를 소개합니다.');
    }
  }, []);

  const yearSections = [
    {
      year: '2025년 2학기',
      data: [
        { subject: '수학', grade1: 89, grade2: 0 },
        { subject: '영어', grade1: 84, grade2: 0 },
        { subject: '국어', grade1: 27, grade2: 0 },
        { subject: '과학', grade1: 13, grade2: 0 }
      ],
      totalGrade1: 213,
      totalGrade2: 0
    },
    {
      year: '2025년 1학기',
      data: [
        { subject: '수학', grade1: 104, grade2: 0 },
        { subject: '영어', grade1: 91, grade2: 0 },
        { subject: '국어', grade1: 19, grade2: 0 },
        { subject: '과학', grade1: 17, grade2: 0 }
      ],
      totalGrade1: 231,
      totalGrade2: 0
    },
    {
      year: '2024년 2학기',
      data: [
        { subject: '수학', grade1: 40, grade2: 0 },
        { subject: '영어', grade1: 38, grade2: 0 },
        { subject: '국어', grade1: 5, grade2: 0 },
        { subject: '과학', grade1: 1, grade2: 0 }
      ],
      totalGrade1: 84,
      totalGrade2: 0
    },
    {
      year: '2024년 1학기',
      data: [
        { subject: '수학', grade1: 62, grade2: 0 },
        { subject: '영어', grade1: 47, grade2: 0 }
      ],
      totalGrade1: 109,
      totalGrade2: 0
    },
    {
      year: '2023년 2학기',
      data: [
        { subject: '수학', grade1: 44, grade2: 0 },
        { subject: '영어', grade1: 37, grade2: 0 }
      ],
      totalGrade1: 81,
      totalGrade2: 0
    },
    {
      year: '2023년 1학기',
      data: [
        { subject: '수학', grade1: 57, grade2: 0 },
        { subject: '영어', grade1: 42, grade2: 0 }
      ],
      totalGrade1: 99,
      totalGrade2: 0
    },
    {
      year: '2022년 2학기',
      data: [
        { subject: '수학', grade1: 37, grade2: 0 },
        { subject: '영어', grade1: 31, grade2: 0 }
      ],
      totalGrade1: 68,
      totalGrade2: 0
    },
    {
      year: '2022년 1학기',
      data: [
        { subject: '수학', grade1: 43, grade2: 0 },
        { subject: '영어', grade1: 26, grade2: 0 }
      ],
      totalGrade1: 69,
      totalGrade2: 0
    }
  ];

  return (
    <div className="min-h-screen bg-neutral-950">
      <Navigation currentPage="results" />

      {/* Hero Section */}
      <section className="pt-20 relative min-h-[600px] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-gray-900">
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/90"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
          <div className="text-center">
            <div className="inline-block px-6 py-2 bg-yellow-400/20 border border-yellow-400/40 rounded-full mb-8">
              <span className="text-yellow-400 text-sm font-semibold tracking-wide">ELITE OF FUTURE</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
              미래인재학원<br />
              <span className="text-yellow-400">탁월한 내신실적</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-16 leading-relaxed max-w-3xl mx-auto">
              체계적인 내신 관리로<br className="md:hidden" />
              이루어낸 자랑스러운 성과
            </p>

            <div className="bg-neutral-900/50 backdrop-blur-sm border border-neutral-800 rounded-3xl p-12">
              <div className="grid grid-cols-1 md:grid-cols-1 gap-6 max-w-2xl mx-auto">
                {/* 1등급 */}
                <div className="bg-gradient-to-br from-yellow-500/20 to-yellow-600/10 backdrop-blur-sm border-2 border-yellow-400/30 rounded-2xl p-8 hover:scale-105 transition-transform duration-300">
                  <div className="text-xl font-semibold text-white mb-4 text-center">
                    1등급 달성
                  </div>
                  <div className="text-6xl font-bold text-yellow-400 text-center mb-3">954건</div>
                  <p className="text-sm text-neutral-400 text-center mb-6">2022년~2025년 총 인원<br />민락 옥정 지행 전 지점 합산</p>
                  <div className="flex justify-center">
                    <a
                      href="https://blog.naver.com/eliteoffuture"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-6 py-2.5 bg-yellow-400 hover:bg-yellow-300 text-black font-semibold rounded-lg transition-all shadow-lg shadow-yellow-400/25 cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-file-list-3-line"></i>
                      명단보기
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Results Sections */}
      {yearSections.map((section, sectionIndex) => (
        <section
          key={section.year}
          className={`py-16 ${
            sectionIndex % 2 === 0
              ? 'bg-neutral-950'
              : 'bg-neutral-900'
          }`}
        >
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Section Header */}
            <div className="flex items-center gap-4 mb-10">
              <div className="inline-block px-5 py-2.5 bg-yellow-400 rounded-lg">
                <div className="text-lg font-bold text-black whitespace-nowrap">
                  {section.year}
                </div>
              </div>
              <div className="h-px flex-1 bg-gradient-to-r from-yellow-400/50 to-transparent"></div>
            </div>

            <div className="flex flex-col lg:flex-row items-stretch gap-6">
              {/* Left - Subject Cards Grid */}
              <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-4">
                {section.data.map((item, index) => (
                  <div
                    key={index}
                    className="bg-neutral-800/80 rounded-2xl border border-neutral-700 hover:border-yellow-400/50 transition-all duration-300 p-5 flex flex-col items-center justify-center"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-yellow-400/10 mb-3">
                      {item.subject === '수학' && (
                        <i className="ri-pie-chart-line text-2xl text-yellow-400"></i>
                      )}
                      {item.subject === '영어' && (
                        <i className="ri-english-input text-2xl text-yellow-400"></i>
                      )}
                      {item.subject === '국어' && (
                        <i className="ri-book-open-line text-2xl text-yellow-400"></i>
                      )}
                      {item.subject === '과학' && (
                        <i className="ri-flask-line text-2xl text-yellow-400"></i>
                      )}
                    </div>
                    <h3 className="text-base font-semibold text-white mb-2">{item.subject.replace(' 1등급', '')}</h3>
                    <div className="text-3xl font-black text-yellow-400">{item.grade1}<span className="text-lg font-bold">건</span></div>
                    {item.grade2 > 0 && (
                      <div className="text-xs text-neutral-400 mt-2 bg-neutral-700/50 px-2 py-1 rounded-full">2등급 {item.grade2}명</div>
                    )}
                  </div>
                ))}
              </div>

              {/* Right - Total Box */}
              <div className="lg:w-48 flex-shrink-0">
                <div className="h-full bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-2xl p-6 flex flex-col items-center justify-center shadow-lg shadow-yellow-400/20">
                  <div className="text-sm font-bold text-black/70 mb-2">1등급 총 달성</div>
                  <div className="flex items-baseline gap-1">
                    <div className="text-5xl font-black text-black">{section.totalGrade1}</div>
                    <div className="text-xl font-bold text-black">건</div>
                  </div>
                  {section.totalGrade2 > 0 && (
                    <div className="mt-3 text-xs font-semibold text-black/60 bg-black/10 px-3 py-1 rounded-full">
                      2등급 {section.totalGrade2}명
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* Footer */}
      <Footer />
    </div>
  );
}
